export default function(isoDuration) {
  // example: 'P39Y2M20DT0H0M0S'
  const timePart = isoDuration.slice(isoDuration.indexOf('T') + 1)
  const hIndex = timePart.indexOf('H')
  const mIndex = timePart.indexOf('M')
  const sIndex = timePart.indexOf('S')
  const h = hIndex === -1 ? '0' : timePart.substring(0, hIndex)
  const m = mIndex === -1 ? '0' : timePart.substring(hIndex + 1, mIndex)
  const s = sIndex === -1 ? '0' : timePart.substring(mIndex + 1, timePart.indexOf('S'))
  return {
    hours: parseInt(h),
    minutes: parseInt(m),
    seconds: parseInt(s),
  }
}
